import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AccountResponse } from '../models/account.model';
import { NomenclatureAccountRequest, NomenclatureAccountResponse } from '../models/nomenclature.model';

@Injectable({
  providedIn: 'root'
})
export class ParticularityInvoiceRoutingServiceService {

  private url = environment.api + "api/erp/particularity/invoice-routing";
  constructor(
    private http: HttpClient,
  ) { }

  saveRoute(request) {
    return this.http.post(this.url, request);
  }

  getRoutesByAdminCompany(companyId) {
    return this.http.get(this.url + "/all/" + companyId);
  }
}
